import React from 'react';

const socketContext = React.createContext({});

export default socketContext;
